module.exports = __webpack_public_path__ + "img/feature_buy_th.bf6df101.png";